import * as React from 'react';
export default function SvgFontFamily() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.185 8.212c.209 1.921.743 4.04.911 5.903m0 0c.203 2.241-.123 4.113-2.178 4.826-1.293.448-2.84-.435-2.652-1.79.093-.676.462-1.37 1.329-1.923.26-.166.554-.27.852-.356l2.649-.757zm0 0L14 13M19.25 4.75C15.5 10.25 8 4 4.75 11.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}